import React from 'react';
const ROW_CONFIG = {
  gutter: [16, 16],
};

export const generateFields = (fields, configs = []) => {
  return fields.map((field, index) => {
    const { name, label, description } = field;
    const config = configs.find((config) => config.fieldName === name);
    return {
      type: config ? config.type : 'DERIVED',
      name: [name, config ? config.name : ''].filter((value) => Boolean(value)),
      description,
      config,
      footNotePosition: 'top',
      label: (
        <div>
          <span style={{ width: 34, paddingRight: 8, display: 'inline-block' }}>#{index + 1}</span>
          <span>{label}</span>
        </div>
      ),
    };
  });
};

export const generateFieldPosition = (fields, layout) => {
  return fields.map((field, index) => {
    const { name } = field;
    const fieldName = Array.isArray(name) ? name.join('.') : name;
    const position = layout[fieldName];
    if (!position)
      return {
        ...field,
        row: {
          position: index,
        },
      };
    return {
      ...field,
      ...position,
      row: {
        ...ROW_CONFIG,
        ...position.row,
      },
    };
  });
};

export const initValue = (fields, configs) => {
  return fields.reduce((acc, field) => {
    const { name } = field;
    const config = configs.find((c) => c.fieldName === name);
    if (config) {
      return {
        ...acc,
        [name]: {
          [config.name]: field[config.name],
        },
      };
    }
    return acc;
  }, {});
};
